import React, { Suspense, lazy } from 'react';
import { Hero } from '../components/Hero';
// Lazy-load everything below the fold — reduces initial JS bundle parse time
const ProductBreakdown = lazy(() => import('../components/ProductBreakdown').then(m => ({
  default: m.ProductBreakdown
})));
const Benefits = lazy(() => import('../components/Benefits').then(m => ({
  default: m.Benefits
})));
const CheckoutSection = lazy(() => import('../components/CheckoutSection').then(m => ({
  default: m.CheckoutSection
})));
const Testimonials = lazy(() => import('../components/Testimonials').then(m => ({
  default: m.Testimonials
})));
const CallToAction = lazy(() => import('../components/CallToAction').then(m => ({
  default: m.CallToAction
})));
const PurchasePopup = lazy(() => import('../components/PurchasePopup').then(m => ({
  default: m.PurchasePopup
})));
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-233">
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100" data-id="element-234">
        <div className="container mx-auto px-4 h-16 flex items-center justify-between" data-id="element-235">
          <div className="font-serif font-bold text-xl text-red-800 flex items-center gap-2" data-id="element-236">
            <span data-id="element-237">🎭</span> DramaTeacherToolkit
          </div>
          <nav className="hidden md:flex items-center gap-6 text-sm font-medium text-gray-600" data-id="element-238">
            <a href="#whats-included" className="hover:text-red-700 transition-colors" data-id="element-239">
              What's Included
            </a>
            <a href="#benefits" className="hover:text-red-700 transition-colors" data-id="element-240">
              Benefits
            </a>
            <a href="#testimonials" className="hover:text-red-700 transition-colors" data-id="element-241">
              Testimonials
            </a>
            <a href="#buy" className="bg-red-700 text-white px-4 py-2 rounded-full hover:bg-red-800 transition-colors text-xs font-bold uppercase tracking-wide" data-id="element-242">
              Buy Now
            </a>
          </nav>
        </div>
      </header>

      <main data-id="element-243">
        {/* Hero is eager — it's above the fold */}
        <Hero data-id="element-244" />

        {/* Everything below the fold is lazy-loaded */}
        <Suspense fallback={null} data-id="element-245">
          <ProductBreakdown data-id="element-246" />
          <div id="benefits" data-id="element-247">
            <Benefits data-id="element-248" />
          </div>
          <CheckoutSection data-id="element-249" />
          <div id="testimonios" data-id="element-250">
            <Testimonials data-id="element-251" />
          </div>
          <CallToAction data-id="element-252" />
        </Suspense>
      </main>

      <footer className="bg-gray-900 text-gray-400 py-12 border-t border-gray-800" data-id="element-253">
        <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-254">
          <div className="text-center md:text-left" data-id="element-255">
            <h3 className="text-white font-serif font-bold text-lg mb-2" data-id="element-256">
              The Ultimate Drama Teacher's Toolkit
            </h3>
            <p className="text-sm" data-id="element-257">
              Educational resources for passionate drama educators.
            </p>
          </div>
          <div className="text-sm text-center md:text-right" data-id="element-258">
            <p data-id="element-259">&copy; {new Date().getFullYear()} All rights reserved.</p>
            <p className="mt-1" data-id="element-260">
              Made with ❤️ for the drama education community.
            </p>
          </div>
        </div>
      </footer>

      <Suspense fallback={null} data-id="element-261">
        <PurchasePopup data-id="element-262" />
      </Suspense>
    </div>;
}